import { db } from "../db/indexeddb";

export class MerchantInvoiceDashboardRepository {
  async saveDashboardSummary(data = {}, org_token = "") {
    if (!data || typeof data !== "object") return null;

    const record = {
      org_id: String(data?.org_id || ""),
      org_token: String(org_token || ""),
      organization: data?.organization || "",
      data,
      synced_at: Date.now(),
    };

    await db.merchant_invoice_dashboard_summary.put(record);
    return record;
  }

  async getDashboardSummary(org_id = "", org_token = "") {
    const normalizedOrgId = String(org_id || "").trim();
    const normalizedOrgToken = String(org_token || "").trim();

    if (normalizedOrgId) {
      const record = await db.merchant_invoice_dashboard_summary.get(
        normalizedOrgId
      );
      if (record) return record;
    }

    if (normalizedOrgToken) {
      const records = await db.merchant_invoice_dashboard_summary
        .where("org_token")
        .equals(normalizedOrgToken)
        .toArray();

      if (records?.length) {
        records.sort((a, b) => (b?.synced_at || 0) - (a?.synced_at || 0));
        return records[0];
      }
    }

    return null;
  }

  async clearDashboardSummary(org_id = "", org_token = "") {
    const normalizedOrgId = String(org_id || "").trim();
    const normalizedOrgToken = String(org_token || "").trim();

    if (normalizedOrgId) {
      await db.merchant_invoice_dashboard_summary.delete(normalizedOrgId);
      return;
    }

    if (normalizedOrgToken) {
      await db.merchant_invoice_dashboard_summary
        .where("org_token")
        .equals(normalizedOrgToken)
        .delete();
    }
  }
}

export const merchantInvoiceDashboardRepository =
  new MerchantInvoiceDashboardRepository();

